import React from 'react'
import { findWidgetIdForPath } from '@/components/editor/widget-dom'
import { useWidgetQueryStatusStore, WidgetQueryStatus } from '@/components/editor/widget-editor/query-status'
import { AnyConfigDesc, VariableFields, WidgetFieldsForm } from '@/components/editor/widget-editor/form-fields'
import { QueryCard } from '@/components/editor/widget-editor/query-card'
import { resizeQuery } from '@/components/editor/widget-selector/query-navigation'

/**
 * The widget's query card, docked in the editor panel, and the widget's other query settings.
 * Query edits stay pending until run, so the widget does not re-query on every keystroke.
 */
export function QueryTab(props: {
  form: WidgetFieldsForm
  selectedPath: string | null
  variables: ReadonlyArray<AnyConfigDesc>
}) {
  const { form, selectedPath } = props
  const queryStatus = useSelectedWidgetQueryStatus(selectedPath)

  const queryEditors = props.variables.filter(v => v.type === "yasgui")
  const queryCompanions = props.variables.filter(v => v.type !== "yasgui")

  return (
    <>
      {selectedPath && queryEditors.length > 0 && (
        <QueryCard size="docked"
                   inSettings
                   title="Query"
                   path={selectedPath}
                   status={queryStatus}
                   fields={queryEditors}
                   applied={form.configDraft as Record<string, unknown>}
                   apply={edits => Object.entries(edits).forEach(([ name, value ]) => form.updateField(name, value))}
                   onResize={size => resizeQuery(selectedPath, size)} />
      )}
      {queryCompanions.length > 0 && (
        <div className="flex flex-col gap-2.5 px-3 py-3">
          <VariableFields form={form} variables={queryCompanions} />
        </div>
      )}
    </>
  )
}

function useSelectedWidgetQueryStatus(selectedPath: string | null): WidgetQueryStatus | null {
  return useWidgetQueryStatusStore(st => st[findWidgetIdForPath(selectedPath) ?? ""] ?? null)
}
